import {Fragment, useContext} from "react";
import {MyContext} from "../context/myContext";

const PasswordFormInput = ({state, handleChange, handleShowPassword}) => {
    const {data, selectedUser} = useContext(MyContext)
    return(
        data.map((item, index) => {
            return(
                <Fragment key={index}>
                    <label className='flex gap-2 justify-end text-right my-2 text-sm md:text-base'>{item.label}{item.id !== 'username' && <span className='text-orange-700'>*</span>}</label>
                    <div className='relative'>
                        {item.id !== 'username' && <i className={`${state.showPass[item.id] ? 'fa fa-eye-slash text-sm sm:text-base' : 'fa fa-eye text-sm sm:text-base'}
                         absolute left-3 top-1/2 -translate-y-1/2 cursor-pointer`} id={item.id} onClick={handleShowPassword}></i>}
                        <input type={state.showPass[item.id] === false ? 'password' : 'text'} name={item.name}
                               value={item.id !== 'username' ? state.password[item.name] : ''}
                               placeholder={item.id !== 'username' ? item.label : selectedUser.userName}
                               onChange={handleChange} readOnly={item.id === 'username'}
                               className='block w-full text-center text-sm md:text-base py-1 md:py-3 border border-1 border-borderColor rounded-md outline-none hover:border-green-500 focus:shadow-focusShadow'
                        />
                    </div>
                </Fragment>
            )
        })
    )
}

export default PasswordFormInput